import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import apiCall from "services/apiCall";
import { getFileContentDetail } from "services/file-service";

const FileDetail = ({ sha }) => {
  const [loading, setLoading] = useState(false);
  const [fileDetail, setFileDetail] = useState("");

  useEffect(() => {
    getPostDetail();
  }, [sha]);

  const getPostDetail = () => {
    setLoading(true);
    apiCall({
      service: getFileContentDetail,
      serviceParams: sha,
      onSuccess: (res) => {
        setFileDetail(res.data);
        setLoading(false);
      },
      onError: (res) => {
        setLoading(false);
      }
    });
  };

  return (
    <div>
      {loading ? (
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <div dangerouslySetInnerHTML={{ __html: fileDetail }} />
      )}
    </div>
  );
};

export default FileDetail;
